// extracted by mini-css-extract-plugin
export default {"image":"_2r9Zh0W"};